module.exports = __webpack_public_path__ + "static/media/2022_IMG_9018.49f87e92.jpg";